export const EVENTS = {
    pseudoLocateAnimation: 'PseudoLocateAnimation',
    cardCheckoutChosen: 'CardCheckoutChosen',
    onboardingSuccessShown: 'OnboardingSuccessShown',
    pseudoUserIconTapped: 'PseudoUserIconTapped',
    successScreenShown: 'OnboardingSuccessShown',
    paymentDeclined: 'PaymentDeclinedInsufFunds',
    plansScreenShown: 'OnboardingPaywallShown',
    checkoutScreenShown: 'OnboardingPaymentShown',
    subBuyTapped: 'SubBuyTapped',
    cardMethodChosen: 'CardCheckoutChosen',
    enterPhoneToTrack: 'EnterPhoneToTrack',
    enterPhoneButtonClick: 'EnterPhoneButton',
    pseudoUserScreenShown: 'PseudoUserScreen',
    IAPPaywall: 'IAPPaywall',
    QRCode: 'QRCode',
    subscribed: 'PaywallSubscribed',
    subBuyFailed: 'SubsPurchaseFailed',
    subBuyClosed: 'PaywallClosed',
    upsellTapped: 'UpsellTapped',
    upsellPurchased: 'UpsellPurchased'
};